import React from "react";
import TripGroupForm from "../components/tripForm/TripGroupForm.tsx";

export const TripGroupsPage: React.FC = () => {
    return <div><TripGroupForm/></div>
}
